import { Component } from '@angular/core';
import { ItemAndStatus } from '../../../va-items-and-status/va-items-and-status';
import { FilterFieldComponent } from '../filter-field.component';
import { MultiItemsAndStatusFilterField } from './filter-field-multi-items-and-status';

@Component({
  selector: 'va-filter-multi-items-and-status',
  template: `
    <va-items-and-status
      *ngFor="let itemAndStatus of filterField.value"
      [options]="filterField.options"
      [itemConfig]="filterField.itemSelectorConfig"
      [statusConfig]="filterField.statusSelectorConfig"
      [editionConfig]="filterField.editionSelectorConfig"
      [appliedSelection]="itemAndStatus"
      (selection)="updateItemAndStatus(itemAndStatus, $event)"
    />
    <va-items-and-status
      *ngIf="selectItemOptions().length > 0 || filterField.options.length === 0"
      [options]="selectItemOptions()"
      [itemConfig]="filterField.itemSelectorConfig"
      [statusConfig]="filterField.statusSelectorConfig"
      [editionConfig]="filterField.editionSelectorConfig"
      [appliedSelection]="emptyItemAndStatus"
      (selection)="addItemAndStatus($event)"
    />
  `,
  styles: [
    `
      va-items-and-status {
        display: block;
      }
      :not(va-items-and-status:last-child) {
        margin-bottom: 10px;
      }
    `,
  ],
  standalone: false,
})
export class MultiItemsAndStatusFilterFieldComponent extends FilterFieldComponent<MultiItemsAndStatusFilterField> {
  public emptyItemAndStatus: ItemAndStatus = { item: null, status: null, edition: null };

  updateItemAndStatus(oldValue: ItemAndStatus, newValue: ItemAndStatus): void {
    this.filterField.updateValue(oldValue, newValue);
    this.filterApplied.emit(this.filterField);
  }

  addItemAndStatus(value: ItemAndStatus): void {
    let selectedValues = this.filterField.value;
    if (this.filterField.value === null) {
      selectedValues = [value];
    } else if (
      !this.filterField.value.some(
        (existingValue) =>
          existingValue.item === value.item &&
          existingValue.status === value.status &&
          existingValue.edition?.editionId === value.edition?.editionId,
      )
    ) {
      // If there is not an existing value with the same item and status, push the new value to the array
      selectedValues!.push(value);
    }
    this.applyFilter(selectedValues);
    this.emptyItemAndStatus = { item: null, status: null, edition: null };
  }

  selectItemOptions(): any[] {
    return this.filterField.options.filter((option) => {
      return !this.filterField.value!.find((itemList) => itemList.item === option.item);
    });
  }
}
